import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import CircularProgress from 'components/atoms/CircularProgress/CircularProgress';
import Box from 'components/atoms/Box/Box';
import Typography from 'components/atoms/Typography/Typography';
import RadialBarChart from 'components/atoms/RadialBarChart/RadialBarChart';
import { useCircleStyles } from './circleStyles';
import { useTheme } from '@material-ui/core';

/**
 * Circle component based on https://material-ui.com/components/progress/#circular-with-label
 * @param {} props
 */
export default function Circle(props) {
  const { children, value, color, ...rest } = props;
  const classes = useCircleStyles(props);

  const theme = useTheme();
  const primaryColor = color ? color : theme && theme.palette.primary.main;
  const secondaryColor = theme && theme.palette.secondary.main;

  const options = {
    chart: {
      sparkline: {
        enabled: true,
      },
    },
    grid: {
      show: false,
      padding: {
        left: 0,
        right: 0,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: '70%',
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
          total: {
            show: false,
          },
        },
      },
    },
    fill: {
      colors: [primaryColor, secondaryColor],
    },
  };

  return (
    <Fragment>
      <Box className={classes.parent}>
        <RadialBarChart
          {...rest}
          series={[100, value ? value : 0]}
          options={options}
        />
        <Box className={classes.inner}>{children}</Box>
      </Box>
    </Fragment>
  );
}

Circle.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
};

Circle.defaultProps = {
  children: undefined,
  value: 0,
};
